import RetsOpenHouse from '@bb/domain/dist/types/RetsOpenHouse';
import React, { useState } from 'react';

type TriggerRetsOpenHouseUpdatePageContextType = {
  retsOpenHouse?: RetsOpenHouse;
  setRetsOpenHouse: React.Dispatch<React.SetStateAction<RetsOpenHouse>>;
  retsOpenHouseId: string;
  setRetsOpenHouseId: React.Dispatch<React.SetStateAction<string>>;
  retsUniqueId: string;
  setRetsUniqueId: React.Dispatch<React.SetStateAction<string>>;
  listingRef: string;
  setListingRef: React.Dispatch<React.SetStateAction<string>>;
  shouldCreateCopy: boolean;
  setShouldCreateCopy: React.Dispatch<React.SetStateAction<boolean>>;
  updates: Record<string, any>;
  setUpdates: React.Dispatch<React.SetStateAction<Record<string, any>>>;
};

const TriggerRetsOpenHouseUpdatePageContext =
  React.createContext<TriggerRetsOpenHouseUpdatePageContextType>(
    {} as TriggerRetsOpenHouseUpdatePageContextType,
  );

export const TriggerRetsOpenHouseUpdatePageProvider: React.FC = ({
  children,
}) => {
  const [retsOpenHouse, setRetsOpenHouse] =
    useState<TriggerRetsOpenHouseUpdatePageContextType['retsOpenHouse']>();
  const [retsOpenHouseId, setRetsOpenHouseId] = useState('');
  const [listingRef, setListingRef] = useState('');
  const [retsUniqueId, setRetsUniqueId] = useState('');
  const [shouldCreateCopy, setShouldCreateCopy] = useState(false);
  const [updates, setUpdates] = useState<
    TriggerRetsOpenHouseUpdatePageContextType['updates']
  >({});

  return (
    <TriggerRetsOpenHouseUpdatePageContext.Provider
      value={{
        retsOpenHouse,
        setRetsOpenHouse,
        retsOpenHouseId,
        setRetsOpenHouseId,
        listingRef,
        setListingRef,
        retsUniqueId,
        setRetsUniqueId,
        shouldCreateCopy,
        setShouldCreateCopy,
        updates,
        setUpdates,
      }}
    >
      {children}
    </TriggerRetsOpenHouseUpdatePageContext.Provider>
  );
};

export default TriggerRetsOpenHouseUpdatePageContext;
